<template>
    <vx-expandable-card>
        <template v-slot:content>
            <div class="flex flex-col gap-4">
                <div>
                    <vx-label size="md">Team Name</vx-label>

                    <vx-input
                        data-test="name-input"
                        autofocus
                        v-model="form.name"
                        size="lg"
                        :error="displayFirstError(validate.name.$errors)"
                    ></vx-input>
                </div>

                <div>
                    <vx-label size="md">Default Contact Time Zone</vx-label>

                    <vx-selectable
                        size="lg"
                        v-model="form.default_contact_time_zone"
                        data-test="default-contact-time-zone"
                        :options="timeZonesList"
                        :reduce="(option) => option.value"
                        :clearable="false"
                        :error="displayFirstError(validate.default_contact_time_zone.$errors)"
                    >
                    </vx-selectable>
                </div>

                <div>
                    <vx-label size="md">HubSpot Company ID</vx-label>

                    <hubspot-company-id-input
                        v-model="form.hubspot_company_id"
                        placeholder="HubSpot Company ID"
                        size="lg"
                        :error="displayFirstError($externalResults.hubspot_company_id)"
                    />
                </div>
            </div>
        </template>
    </vx-expandable-card>
</template>
<script setup>
import { VxExpandableCard, VxInput, VxLabel, VxSelectable } from '@voxie/frontend-components';
import HubspotCompanyIdInput from '~/components/general/HubspotCompanyIdInput.vue';
import useVuelidate from '@vuelidate/core';
import { maxLength, required } from '@vuelidate/validators';
import { csvInjection, displayFirstError } from '~/utils/validation';
import { useFormRequestHandler } from '~/composables/useFormRequestHandler';
import { timeZoneOptions } from '~/utils/timeZones';
import { computed } from 'vue';

const { $externalResults } = useFormRequestHandler();

const form = defineModel({
    type: Object,
    required: true,
});

const timeZonesList = computed(() =>
    timeZoneOptions(form.value.default_contact_time_zone).map((timeZone) => ({
        value: timeZone,
        label: timeZone.split('_').join(' '),
    }))
);

const validate = useVuelidate(
    {
        name: {
            required: required,
            maxLength: maxLength(120),
            csvInjection: csvInjection,
        },
        default_contact_time_zone: {
            required: required,
            maxLength: maxLength(30),
        },
        hubspot_company_id: {},
    },
    form
);
</script>
